import { urlCarriesSecret } from './utils/telemetry';

type AnalyticsWindow = Window & { dataLayer?: unknown[]; gtag?: (...args: unknown[]) => void };

let decided = false;

// GA sends each later navigation, Back included, with the new and previous URL verbatim, so it runs only on a page that loaded without a token.
export const startGoogleAnalytics = (): void => {
  if (decided) return;
  decided = true;

  const trackingId = process.env.REACT_APP_GA_TRACKING_ID;
  if (!trackingId || urlCarriesSecret(window.location.href)) return;

  const analyticsWindow = window as AnalyticsWindow;
  analyticsWindow.dataLayer = analyticsWindow.dataLayer || [];
  analyticsWindow.gtag = function gtag() {
    // gtag.js acts only on commands pushed as an arguments object, not as an array.
    // eslint-disable-next-line prefer-rest-params
    analyticsWindow.dataLayer?.push(arguments);
  };
  analyticsWindow.gtag('js', new Date());
  analyticsWindow.gtag('config', trackingId);

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(trackingId)}`;
  document.head.appendChild(script);
};
